const getYearDifference = (date1String: string) => {
  const date1: any = new Date(date1String);
  const date2: any = new Date();
  const diffTime = Math.abs(date2 - date1);
  const diffYears = Math.floor(diffTime / (1000 * 60 * 60 * 24 * 365));

  return diffYears;
};

// const getYearDifference = (dob: string) => {
//   const birthDate = new Date(dob);
//   const today = new Date();

//   let years = today.getFullYear() - birthDate.getFullYear();
//   let months = today.getMonth() - birthDate.getMonth();
//   let days = today.getDate() - birthDate.getDate();
//   // Adjust if the month difference is negative
//   if (months < 0) {
//     years--;
//     months += 12;
//   }

//   // Adjust if the day difference is negative
//   if (days < 0) {
//     months--;
//     const previousMonth = new Date(today.getFullYear(), today.getMonth(), 0);
//     days += previousMonth.getDate();
//   }
//   console.log("", years, months, days);
// };

export default getYearDifference;
